<template>
  <div class="random-drawer">
    <h1>随机抽取</h1>
    <button @click="startDrawing">开始抽取</button>
    <transition-group name="list" tag="ul">
      <li v-for="(name, index) in drawnNames" :key="index" class="drawn-name">
        {{ name }}
      </li>
    </transition-group>
    <p v-if="!drawingInProgress && drawnNames.length === 3">抽取结束！</p>
  </div>
</template>

<script>
export default {
  name: 'RandomDrawer',
  data() {
    return {
      allNames: ['33号','157号', '272号'],
      drawnNames: [],
      drawingInProgress: false,
    };
  },
  methods: {
    async startDrawing() {
      this.drawingInProgress = true;
      this.drawnNames = [];

      for (let i = 0; i < 3; i++) {
        await this.drawOneName();
        // 模拟抽取过程中的延迟，以显示抽取动画
        await new Promise(resolve => setTimeout(resolve, 1000));
      }

      this.drawingInProgress = false;
    },
    drawOneName() {
      const remainingNames = this.allNames.filter(name => !this.drawnNames.includes(name));
      if (remainingNames.length === 0) return;

      const randomIndex = Math.floor(Math.random() * remainingNames.length);
      const selectedName = remainingNames[randomIndex];
      this.drawnNames.push(selectedName);
    }
  }
};
</script>

<style scoped>
.random-drawer {
  text-align: center;
}

button {
  margin-bottom: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

.drawn-name {
  font-size: 1.5em;
  margin: 10px 0;
}

.list-enter-active, .list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
